import { t } from '@lingui/macro'
import { UserModelAsAdminQueries } from '../../../app-admin/graphql/SuperuserSchemaTypes'

export const prepareUserListExportCSV = (data: UserModelAsAdminQueries[]) =>
  data.map((user) => ({
    [t`ID`]: user.id,
    [t`Email`]: user.email,
    [t`Display name`]: user.display_name,
    [t`First name`]: user.first_name,
    [t`Last name`]: user.last_name,
    [t`Account name`]: user.account_name,
    [t`Mobile`]: user.phone_number,
    [t`Employee ID`]: user.employee_id,
    [t`Position`]: user.position,
    [t`Location`]: user.location,
    [t`Department`]: user.department,
    [t`Area`]: user.area,
    [t`Timezone`]: user.timezone,
    [t`Custom 1`]: user.custom_1,
    [t`Custom 2`]: user.custom_2,
    [t`Custom 3`]: user.custom_3,
    [t`Last activity`]: user.last_activity_at,
    [t`Member in groups`]: user.memberInGroups,
    [t`Manager ID`]: user.manager_id,
    [t`Manager email`]: user.manager?.email,
    [t`Manager account name`]: user.manager?.account_name,
    [t`Manager display name`]: user.manager?.display_name
  }))
